export const AGENT_PHASES = {
  IDLE: 'idle',
  RUNNING: 'running',
  COMPLETE: 'complete',
  ERROR: 'error',
  GENERATING_CARD: 'generating_card',
  DREAM_CARD: 'dream_card',
  EMAIL: 'email',
  GOODBYE: 'goodbye',
} as const;
export type AgentPhase = (typeof AGENT_PHASES)[keyof typeof AGENT_PHASES];

export const AGENT_EVENT_TYPES = {
  AGENT_START: 'AGENT_START',
  THINKING: 'THINKING',
  AGENT_COMPLETE: 'AGENT_COMPLETE',
  AGENT_ERROR: 'AGENT_ERROR',
  TOOL_START: 'TOOL_START',
  TOOL_END: 'TOOL_END',
  TOOL_ERROR: 'TOOL_ERROR',
} as const;
